import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  removeUnsynchronizedEntityAndRefetch,
  synchronizeEntity,
} from '../../actions/OfflineDataActions';
import { HOME } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { createFullEntityOffline } from '../actions/form-manager.actions';
import { getOfflineSavedEntity, getUnsynchronizedEntityId } from '../selectors/common.selectors';

const useStyles = makeStyles({
  modal: {
    '& div:nth-child(3)': {
      justifyContent: 'center',
    },
    '& div:nth-child(3) > div': {
      flexDirection: 'column',
    },
    '& div:nth-child(3) > div > button': {
      marginBottom: 8,
      marginLeft: 0,
    },
  },
});

const SynchronizeChangesDialog = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { width } = useWindowDimensions();

  const translateString = useTranslation();
  const dispatch = useDispatch();
  const unsynchronizedEntityId = useSelector(getUnsynchronizedEntityId);
  const savedEntity = useSelector(getOfflineSavedEntity(unsynchronizedEntityId));

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (unsynchronizedEntityId !== undefined) {
      setOpen(true);
    }
  }, [unsynchronizedEntityId]);

  const handleSynchronizeChanges = () => {
    setOpen(false);
    dispatch(synchronizeEntity());
  };

  const handleDiscardChanges = () => {
    setOpen(false);
    dispatch(removeUnsynchronizedEntityAndRefetch(location));
  };

  const handleOpenLocalCopy = () => {
    setOpen(false);
    dispatch(createFullEntityOffline(savedEntity));
  };

  const onClose = () => {
    setOpen(false);
    history.push(HOME);
  };

  return (
    <Modal
      className={width < 560 ? classes.modal : null}
      open={open}
      onClose={onClose}
      title={translateString('Choose necessary action')}
      message={translateString('You have unsynchronized local changes for this Task')}
      buttonProps={[
        {
          variant: 'primary',
          label: translateString('Discard local changes'),
          onClick: handleDiscardChanges,
        },
        {
          variant: 'primary',
          label: translateString('Open local copy'),
          onClick: handleOpenLocalCopy,
        },
        {
          label: translateString('Synchronize'),
          onClick: handleSynchronizeChanges,
        },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    />
  );
};

export default SynchronizeChangesDialog;
